import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApplicationDataService } from './application-data.service';
import * as _ from 'underscore';
import { ProjectService } from './project.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private httpClient: HttpClient,
    private projectService: ProjectService,
    private applicationDataService: ApplicationDataService) { }

  signIn(signInDetails: any) {
    return this.applicationDataService.initEnvironments().pipe(
      switchMap(env =>
        this.httpClient.post(env.APIcalling + '/csr/auth/login/v1', signInDetails).pipe(map((res: any) => {
          return res;
        }))
      )
    );
  }

  hasElementPermission(elementName: any) {
    let flag = false;
    let page_permission = sessionStorage.getItem('page_permission')?.split(",");
    if (page_permission !== null && page_permission !== undefined) {
      if (_.contains(page_permission, elementName.toLowerCase())) {
        flag = true;
      } else {
        flag = false;
      }
    }
    return flag
  };

  logoutFromAll() {
    return this.applicationDataService.initEnvironments().pipe(
      switchMap(env =>
        this.httpClient.delete(env.APIcalling + '/csr/auth/logout/v1').pipe(map((res: any) => {
          return res;
        }))
      )
    );
  }

  destroyStorage() {
    this.projectService.selectedProject.set(null);
    sessionStorage.clear();
  }
}
